import React, { useEffect } from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("privacy-page");

    return () => {
      document.body.classList.remove("privacy-page");
    };
  }, []);

  return (
    <div className="privacy-policy">
      {/* Header */}
      <div className="privacy-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="header-subtitle">
            Your privacy is important to us. Please read how we collect, use,
            and protect your data.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="privacy-content">
        <div className="container">
          <div className="privacy-card">
            {/* Introduction */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">1</div>
              </div>
              <div className="section-content">
                <h2>Introduction</h2>
                <p>
                  Kubersetu operates the website{" "}
                  <a href="https://www.kubersetu.com" className="website-link">
                    https://www.kubersetu.com
                  </a>
                  . This Privacy Policy outlines how we collect, use, share, and
                  protect your personal information when you use our financial
                  services.
                </p>
              </div>
            </div>

            {/* Information We Collect */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">2</div>
              </div>
              <div className="section-content">
                <h2>Information We Collect</h2>

                <div className="info-category">
                  <h3>Personal Information</h3>
                  <p>
                    When you apply for a loan or use our services, we collect
                    details such as your name, address, email, phone number,
                    date of birth, gender, and employment type.
                  </p>
                </div>

                <div className="info-category">
                  <h3>Financial Information</h3>
                  <p>
                    Includes bank account details, credit history, PAN card,
                    Aadhaar number, and other documents required for financial
                    assessment.
                  </p>
                </div>

                <div className="info-category">
                  <h3>Usage Information</h3>
                  <p>
                    Includes technical data like IP address, browser type,
                    device info, and browsing behavior.
                  </p>
                </div>

                <div className="info-category">
                  <h3>Identification Documents</h3>
                  <p>
                    We may require scanned copies of government-issued IDs for
                    identity verification.
                  </p>
                </div>
              </div>
            </div>

            {/* How We Use Your Information */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">3</div>
              </div>
              <div className="section-content">
                <h2>How We Use Your Information</h2>
                <p>
                  We use your information to evaluate loan applications, verify
                  identity, prevent fraud, maintain your account, and comply
                  with legal obligations including the Prevention of Money
                  Laundering Act, 2002. We do not share your data with
                  third-party marketers without your explicit consent.
                </p>
              </div>
            </div>

            {/* Data Security */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">4</div>
              </div>
              <div className="section-content">
                <h2>Data Security</h2>
                <p>
                  We implement technical and organizational safeguards including
                  encryption, secure servers, and access controls to protect
                  your data. However, no system is completely secure.
                </p>
              </div>
            </div>

            {/* Your Rights */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">5</div>
              </div>
              <div className="section-content">
                <h2>Your Rights</h2>
                <p>
                  Subject to applicable laws, you have rights to access,
                  correct, delete, or restrict the processing of your personal
                  data. You may also withdraw consent for data use when no
                  longer required, especially after loan closure.
                </p>
              </div>
            </div>

            {/* Data Retention and Deletion */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">6</div>
              </div>
              <div className="section-content">
                <h2>Data Retention and Deletion</h2>
                <p>
                  We retain personal data as necessary for internal records and
                  compliance. You can request data deletion if your credit
                  obligations are settled, subject to regulatory permissions.
                </p>
              </div>
            </div>

            {/* Cookies and Tracking */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">7</div>
              </div>
              <div className="section-content">
                <h2>Cookies and Tracking</h2>
                <p>
                  We use cookies to enhance your experience and track website
                  usage. You may adjust cookie settings in your browser.
                </p>
              </div>
            </div>

            {/* Grievance Officer */}
            <div className="policy-section grievance-section">
              <div className="section-number-wrapper">
                <div className="section-number">8</div>
              </div>
              <div className="section-content">
                <h2>Grievance Officer</h2>
                <p className="grievance-intro">
                  For concerns regarding your data, please contact our Grievance
                  Officer:
                </p>

                <div className="contact-info">
                  <div className="contact-item">
                    <span className="contact-label">Phone:</span>
                    <span className="contact-value">+91-9660236005</span>
                  </div>

                  <div className="contact-item">
                    <span className="contact-label">Email:</span>
                    <div className="contact-emails">
                      <a
                        href="mailto:kubersetu@gmail.com"
                        className="contact-link"
                      >
                        kubersetu@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="contact-item">
                    <span className="contact-label">Address:</span>
                    <span className="contact-value">
                      88-E, 2nd Floor, Near Punjab and Sind Bank, Jindal Chowk, Hisar, Haryana - 125001
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Updates to Privacy Policy */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">9</div>
              </div>
              <div className="section-content">
                <h2>Updates to Privacy Policy</h2>
                <p>
                  This Privacy Policy may be updated from time to time. Any
                  changes will be posted on our website with the revised
                  effective date.
                </p>
              </div>
            </div>
          </div>

          {/* Footer Note */}
          <div className="privacy-footer-note">
            <p>
              By using our services, you acknowledge that you have read and
              understood this Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
